var NMAListActions, NMAQuestionActions, NMA_OUTCOME_PREFIX, NMA_QUESTION_PREFIX, NmaOutcomeDoc, W, alt, appUtils, callMethod, gdtDataToNmaData, generateActions, mediator, _ref;

alt = require('alt');

appUtils = require('lib/app_utils');

callMethod = require('base/lib/utils').callMethod;

gdtDataToNmaData = require('lib/nma_helper').gdtDataToNmaData;

generateActions = require('actions/utils/generate_actions');

_ref = require('lib/doc_prefixes'), NMA_OUTCOME_PREFIX = _ref.nmaOutcome, NMA_QUESTION_PREFIX = _ref.nmaQuestion;

mediator = require('mediator');

NMAListActions = require('actions/nma_list_actions');

NMAQuestionActions = require('actions/nma_question_actions');

NmaOutcomeDoc = require('lib/db_docs/nma_outcome_doc');

W = require('when/when');

module.exports = generateActions({
  autoGenerate: ['closeAutoCalculateModal', 'closeExportModal', 'closeForestPlot', 'closeNetworkGraph', 'fetchError', 'fetchSuccess', 'openAutoCalculateModal', 'openExportModal', 'openForestPlot', 'openNetworkGraph', 'selectComparator', 'selectDenominator', 'selectInterventionIds', 'selectOutcomeIds', 'setAutoCalculateOptions', 'setComparatorTableMode', 'setSymbolsInsteadOfLettersAsFootnote', 'setTableOrder', 'toggleCertaintyIcons', 'toggleHighlights', 'toggleThresholds', 'toggleTransposed'],
  name: 'NMAVizActions',
  actions: {
    dbChange: function(change, _pending, _lastSeq) {
      var isOutcome, isQuestion;
      isOutcome = change.id.indexOf(NMA_OUTCOME_PREFIX) === 0;
      isQuestion = change.id.indexOf(NMA_QUESTION_PREFIX) === 0;
      if (!(isOutcome || isQuestion)) {
        return;
      }
      return this.dispatch(change);
    },
    fetch: function(_arg) {
      var dbId, docId;
      dbId = _arg.dbId, docId = _arg.docId;
      this.dispatch();
      return W.all([
        NMAListActions.fetch({
          dbId: dbId
        }), NmaOutcomeDoc.at(dbId).fetchMany()
      ]).then((function(_this) {
        return function(_arg1) {
          var outcomes, outcomesResult, question, questions;
          questions = _arg1[0], outcomesResult = _arg1[1];
          question = _.find(questions, function(doc) {
            return doc._id === docId;
          });
          outcomes = _.chain(outcomesResult.rows).pluck('doc').compact().filter(function(doc) {
            return doc.questionId === docId;
          }).value();
          if (!question) {
            throw new Error("No question " + docId);
          }
          NMAQuestionActions.fetchQuestionSuccess({
            setCurrentQuestionId: true,
            question: question
          });
          NMAQuestionActions.fetchOutcomesSuccess(outcomes);
          return _this.actions.fetchSuccess({
            outcomes: outcomes,
            question: question
          });
        };
      })(this))["catch"]((function(_this) {
        return function(err) {
          appUtils.errorHandlerWithMsg(err, $.t('nma:viz.fetch_error'));
          return _this.actions.fetchError(err);
        };
      })(this));
    },
    autoCalculateEffectClassification: function() {
      var autoCalculationType, methodToAutoCalculate, modalState, options, question;
      question = alt.stores.NMAQuestionStore.getCurrentQuestion();
      modalState = alt.stores.NMAVizStore.getAutoCalculateModalState();
      autoCalculationType = modalState.get('type');
      methodToAutoCalculate = autoCalculationType === 'effectClassification' ? 'autoCalculateEffectClassification' : 'autoCalculateEffectInterpretation';
      options = modalState.get('options').toJS();
      return NmaOutcomeDoc.at(mediator.project.id, modalState.get('outcomeId')).updateAsInstance(callMethod(methodToAutoCalculate, _.extend({}, options, {
        question: question
      }))).then(function() {
        var successMessageKey;
        successMessageKey = autoCalculationType === 'effectClassification' ? 'nma:autocalculation_modal.auto_calculate_effect_classification_success' : 'nma:autocalculation_modal.auto_calculate_effect_interpretation_success';
        return mediator.dialogs.info($.t(successMessageKey));
      })["catch"](function(err) {
        appUtils.errorHandlerWithMsg(err, $.t('nma:autocalculation_modal.auto_calculate_error'));
        return this.actions.fetchError(err);
      })["finally"]((function(_this) {
        return function() {
          return _this.actions.closeAutoCalculateModal();
        };
      })(this));
    }
  }
});
